import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "/call-templates",
        name: "CallTemplates",
        component: () => import("./views/callTemplateList"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/audio-list",
        name: "AudioList",
        component: () => import("./views/audioList"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/audio-list/create",
        name: "CreateAudio",
        component: () => import("./views/audio"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/call-templates/create",
        name: "CreateTemplate",
        component: () => import("./views/callTemplate"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/call-templates/update/:id",
        name: "UpdateTemplate",
        component: () => import("./views/callTemplate"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
